import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { v1 as uuidv1 } from "uuid";

import "./DataModelWithCubes.scss";

const initialValues = {
  dataModelInfo: undefined,
  dataModelCubes: undefined,
  initialExpanded: false,
  includesCubesWithHierarchies: true,
  openLinksInNewTabs: false,
  store: undefined,
  isDetailViewStore: undefined,
  type: undefined,
};

export const DataModelWithCubes = ({
  dataModelInfo,
  dataModelCubes,
  initialExpanded,
  includesCubesWithHierarchies,
  openLinksInNewTabs,
  store,
  isDetailViewStore,
  type,
} = initialValues) => {
  const [expanded, setExpanded] = useState(initialExpanded);

  const handleShowHide = () => {
    setExpanded((expanded) => !expanded);
  };

  const cubeTypeText = "Individual cubes:";
  const today = new Date();

  return (
    <div className="DataModelWithCubes">
      <div className="data-model">
        {dataModelInfo.tid ? (
          <React.Fragment>
            {isDetailViewStore && type === "Framework" ? (
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  // store.clearEntityData();
                  store.setType(dataModelInfo.type);
                  store.setTid(dataModelInfo.tid);
                }}
                to={`/view/${dataModelInfo.type}/${dataModelInfo.tid}`}
                title={`${dataModelInfo.name || "[No name]"} (${
                  dataModelInfo.code
                })`}
              >
                {`${dataModelInfo.name || "[No name]"}`}
              </Link>
            ) : (
              <Link
                onClick={() => {
                  store.clearEntityData();
                }}
                title={`${dataModelInfo.name || "[No name]"} (${
                  dataModelInfo.code
                })`}
                to={`/view/${dataModelInfo.type}/${dataModelInfo.tid}`}
              >
                {`${dataModelInfo.name || "[No name]"}`}
              </Link>
            )}

            {` (${dataModelInfo.code}) `}
            <span className="object-type label label-success">Data model</span>
          </React.Fragment>
        ) : (
          <span>{cubeTypeText}</span>
        )}{" "}
        {includesCubesWithHierarchies && (
          <Button
            bsSize="xsmall"
            onClick={handleShowHide}
            bsClass="btn btn-default btn-xs dropdown-toggle"
          >
            {expanded ? "hide" : "show"}{" "}
            {dataModelCubes.length > 1
              ? `${dataModelCubes.length} cubes`
              : "1 cube"}
          </Button>
        )}
      </div>
      {expanded && (
        <ul className={`cube-list ${expanded ? "expanded" : "collapsed"}`}>
          {dataModelCubes.map((cube) => (
            <li key={uuidv1()} className="cube-list-item">
              <div className="cube-name">
                {isDetailViewStore && type === "Framework" ? (
                  <Link
                    onClick={(e) => {
                      // store.clearEntityData();
                      e.preventDefault();
                      store.setType(cube.type);
                      store.setTid(cube.tid);
                    }}
                    title={`${dataModelInfo.name || "[No name]"} (${
                      dataModelInfo.code
                    })`}
                    to={`/view/Cube/${cube.tid}`}
                  >
                    {`${cube.name || "[No name]"}`}
                  </Link>
                ) : (
                  <Link
                    onClick={() => {
                      store.clearEntityData();
                    }}
                    title={`${cube.name || "[No name]"} (${cube.code})`}
                    to={`/view/Cube/${cube.tid}`}
                  >
                    {`${cube.name || "[No name]"}`}
                  </Link>
                )}
                {` (${cube.code}) `}
                {cube.validTo != null && new Date(cube.validTo) < today ? (
                  <span className="object-type label label-default">
                    Discontinued
                  </span>
                ) : (
                  ""
                )}
                <span className="object-type label label-success">Cube</span>{" "}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
